import { call, put } from 'redux-saga/effects';
import { apiMethods } from '~/services/api';

export function* callAndDispatch<P = any>(method: string, payload: P): any {
  const response = yield call((apiMethods as any)[method], payload);
  yield put({ type: method, payload: response });
  return response;
}
